<template>
	<page-layout class="calendar-page" title="Timer">
		<div class="content">
			<div class="header">
				<div class="date" @click="dateClick">{{ months[(new Date(date)).getMonth()] }} {{ (new Date(date)).getFullYear() }}</div>
				<div class="total"><span v-if="hours.extra > 0" style="font-size: 12px;">+{{ $filters.hours(hours.extra) }}</span> {{ $filters.hours(hours.hours) }} t</div>
			</div>
			<div class="body">
				<div class="table">




					<div v-for="(item, i) in hours.days" :key="i" class="item">
						<div class="color" :style="{
							backgroundColor: item.approved === null ? (item.hours == 0 ? '#aaa' : '#e0d800') : '#00c017'
						}"></div>
						<div class="title">{{ (new Date(item.date)).getDate() }}. {{ months[(new Date(item.date)).getMonth()] }} {{ (new Date(item.date)).getFullYear() }}</div>
						<div class="sub-title">{{ item.tasks.join(', ') }}</div>
						<div v-if="item.approved === null && item.hours > 0" class="arrival">Afventer</div>
						<div v-if="item.approved === null && item.hours == 0" class="arrival empty"></div>
						<div v-if="item.approved !== null" class="arrival approved"><span v-if="item.extra > 0">+{{ $filters.hours(item.extra) }}</span> {{ $filters.hours(item.approved) }} t</div>
						<div v-if="item.approved !== null || item.hours > 0" class="info">
							<div class="tag hours">{{ $filters.hours(item.hours) }} t</div>
							<div class="tag pause">{{ $filters.hours(item.pause) }} t</div>
						</div>
						<div class="log">
							<div v-for="(log, j) in item.log" :key="j">
								<div class="type">{{ log.type_str }}<div v-if="log.error" class="error">{{ log.error }}</div></div>
								<div class="time">{{ $filters.time(log.timestamp) }}</div>
							</div>
						</div>
						<div v-if="item.error" class="error">{{ item.error }}</div>
						<div v-if="item.remarks.length > 0" class="remarks">
							<div v-for="(remark, j) in item.remarks" :key="j">
								<div class="message">{{ remark.message }}</div>
								<div class="author">{{ remark.author }}</div>
							</div>
						</div>
					</div>



				
				</div>
			</div>
		</div>
	</page-layout>
</template>

<script>
	import PageLayout from '@/app/layouts/PageLayout'
	import UserFragment from '@/app/fragments/UserFragment'
	import MonthPopupView from '@/components/MonthPopupView'

	export default {
		components: {
			pageLayout: PageLayout
		},
		data() {
			return {
				date: (new Date()).format('Y-m-d'),
				columns: [
					{
						data: ['username'],
						label: 'Username'
					},
					{
						type: 'button',
						data: {
							event: 'delete',
							label: 'Delete'
						},
						label: '',
						weight: '200px',
						align: 'right'
					}
				],
				hours: {
					hours: 0,
					extra: 0,
					days: []
				},
				months: [
					'januar',
					'februar',
					'marts',
					'april',
					'maj',
					'juni',
					'juli',
					'august',
					'september',
					'oktober',
					'november',
					'december'
				]
			};
		},
		watch: {
			date(n) {
				//this.reservations = [];
				//this.bookings = [];
				this.update();

				localStorage.setItem('hours_date', n);

				console.log('Date stored!!');
			}
		},
		computed: {
			_taskTypes() {
				return [];
			},
			_instructions() {
				return [];
			},
			_hours() {
				return this.hours.filter((item) => {
					return true;
				});
			}
		},
		methods: {
			taskTouchHandler(id) {
				var self = this;

				return function (direction, event) {
					//self.$router.push({ name: 'move', params: { id: id } })
				}
			},
			arrival(book) {
				//console.log('print arrival', book.due_start_from.replace('+', 'T'), new Date(book.due_start_from.replace('+', 'T')));

				var from 	= this.$filters.moment(book.due_start_from, 'HH:mm');
				var to 		= this.$filters.moment(book.due_start_to, 'HH:mm');

				return from == to ? from : from + ' - ' + to;
			},
			zip(book) {
				if (book.type == 'move') {
					var zip1 = book.details.route[0].zip;
					var zip2 = book.details.route[book.details.route.length - 1].zip;
					return zip1 == zip2 ? zip1 : zip1 + ' - ' + zip2;
				}

				return book.details.address.zip;
			},
			tags(book) {
				var r = [];

				if (book.type == 'move') {
					for (var i = 0; i < book.details.route.length; ++i) {
						if (!Array.isArray(book.details.route[i].instructions)) {
							for (var instr in book.details.route[i].instructions) {
								//var name = book.details.route[i].instructions[instr];
								if (!r.includes(instr)) r.push(instr);
							}
						}
					}
				}

				return r;
			},
			create() {
				var self = this;

				this.$store.commit('pushModal', {
					component: UserFragment,
					props: {},
					events: {
						created() {
							self.update();
						}
					}
				});

				
			},
			getOrder(sortable) {
				console.log('get order', sortable);

				var tasks = Array.from(this.bookings);

				tasks.sort(function (a, b) {
					if (a.order < b.order) return -1;
					if (a.order > b.order) return 1;
					return 0;
				});

				var order = tasks.map(function (item) {
					return item.id;
				});
				
				console.log('order', order);

				return order;
			},
			setOrder(sortable) {
				console.log('set order', sortable.toArray());
				this.axios.put('/employees/me/tasks/order/', sortable.toArray());
			},
			itemMove(e) {
				/*console.log('item moved 5', e, this.bookings);

				// Change pos in list
				console.log('before', this.bookings.map(function (item) { return item.num; }));

				this.bookings.move(e.oldIndex - 1, e.newIndex - 1);

				console.log('after', this.bookings.map(function (item) { return item.num; }));
				
				var ids = this.bookings.map(function (item) {
					return item.booking_id;
				});

				console.log(ids);

				this.axios.put('/employees/me/bookings/order', ids);*/
			},
			itemClick(item) {
				var self = this;

				console.log(item);

				this.$store.commit('pushModal', {
					component: UserFragment,
					props: {
						id: item.id
					},
					events: {
						updated() {
							self.update();
						}
					}
				});
			},
			itemDelete(item) {
				var self = this;

				this.axios.delete('/portal/users/' + item.id + '/').then(function () {
					self.update();
				});
			},
			update() {
				var self = this;

				const d = new Date(this.date);

				console.log('update', d);

				this.axios.get('/me/hours/' + d.getFullYear() + '/' + (d.getMonth() + 1) + '/').then(function (r) {
					self.hours = r.data;
				});
			},
			dateClick() {
				var self = this;

				this.$store.commit('pushPopup', {
					component: MonthPopupView,
					props: {
						title: 'Vælg måned',
						date: this.date,
						callback(e) {
							console.log(e);
							self.date = e;
							self.$store.commit('popPopup');
						},
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			}
		},
		created() {
			//console.log('CREATE CalendarView');
			//localStorage.removeItem('calendar_date');
		},
		mounted() {
			console.log('mounted');

			var date = localStorage.getItem('hours_date');

			if (date) {
				console.log('date found', date, new Date(date));
				this.date = date
				this.update();
			} else {
				this.update();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.calendar-page {
		& > .content {
			display: grid;
			grid-template-rows: 60px 1fr;

			& > .header {
				border-bottom: 4px solid #f0f0f0;
				font-size: 14px;
				font-weight: bold;
				padding-left: 20px;
				line-height: 60px;
				position: relative;

				& > .icon {
					width: 24px;
					height: 24px;
				}

				& > .date {
					text-transform: capitalize;
				}

				& > .total {
					position: absolute;
					top: 0;
					right: 20px;
					color: rgb(36, 165, 11);
				}
			}

			& > .body {
				overflow-y: auto;
				background: rgb(241, 241, 241);

				& > .table {
					display: grid;
					row-gap: 10px;
					padding: 10px;
					overflow-y: auto;

					& > .item {
						background-color: white;
						position: relative;
						border-radius: 5px;
						overflow: hidden;
						min-height: 63px;

						-webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
						-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
						box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);

						& > .color {
							position: absolute;
							left: 0;
							top: 0;
							width: 5px;
							height: 100%;
						}

						& > .title {
							font-size: 18px;
							font-weight: bold;
							position: absolute;
							left: 15px;
							top: 8px;
							right: 120px;
							line-height: 24px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;

							& > .completed {
								position: relative;
								top: -1px;
								padding: 2px 5px 2px 5px;
								background-color: rgb(36, 165, 11);
								color: white;
								text-align: center;
								border-radius: 3px;
								margin-right: 5px;
								font-size: 14px;
								line-height: 18px;
								font-weight: normal;
							}
						}

						& > .arrival {
							position: absolute;
							right: 10px;
							top: 10px;
							font-size: 16px;
							line-height: 18px;
							font-weight: bold;
							color: black;

							&.approved {
								color: rgb(36, 165, 11);
							}
						}

						& > .sub-title {
							position: absolute;
							left: 15px;
							top: 33px;
							line-height: 18px;
							padding-top: 5px;
						}

						& > .info {
							position: absolute;
							right: 10px;;
							top: 35px;

							& > .tag {
								color: black;
								margin-left: 5px;
								font-size: 12px;
								padding: 0 3px 0 3px;
								border: 1px solid #e6e6e6;
								border-radius: 3px;
								line-height: 16px;
								float: left;
								background-color: #e6e6e6;

								&.pause {
									border-color: #f3eb00;
									background-color: #f3eb00;
									color: black;
								}
							}
						}

						& > .log {
							margin: 64px 0 0 0;

							& > div {
								padding: 5px 0 5px 13px;
								border-top: 1px solid rgb(226, 226, 226);
								display: grid;
								grid-template-columns: 1fr 60px;

								& > .type {
									& > .error {
										padding-top: 5px;
										color: #F7223F;
									}
								}

								& > .time {
									text-align: right;
									padding-right: 10px;
								}								
							}
						}

						& > .error {
							padding: 5px 0 5px 13px;
							border-top: 1px solid rgb(226, 226, 226);
							color: #F7223F;
						}

						& > .remarks {
							margin: 0 0 0 0;

							& > div {
								padding: 5px 0 5px 13px;
								border-top: 1px solid rgb(226, 226, 226);

								& > .author {
									font-size: 12px;
									font-weight: bold;
									padding-top: 5px;
								}
							}
						}

						& > .tags {
							margin-top: 61px;
							border-top: 1px solid rgb(221, 221, 221);
							padding: 10px;

							& > .tag {
								background-color: #F7223F;
								color: white;
								margin: 0 5px 10px 0;
								font-size: 12px;
								padding: 0 3px 0 3px;
								border: 1px solid #F7223F;
								border-radius: 3px;
								line-height: 16px;
								float: left;
							}
						}

						&.green {
							background-color: #00c017;
							color: white;
						}

						&.yellow {
							background-color: #e0d800;
							color: white;
						}

						&.red {
							background-color: #F7223F;
							color: white;
							height: 40px;
							min-height: 0;
						}

						&.closed {
							background-color:rgb(36, 165, 11);
							color: white;

							& > .info > .tag {
								color: white;
								border: 1px solid white;
							}
						}
					}
				}
			}
		}
	}
</style>